<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

export default {

    page: {
        title: 'Новая услуга',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader },

    data() {
        return {
            title: 'Новая услуга',
            items: [],
            product_uuid: '',
            name: '',
            code: ''
        }
    },

    computed: {
        product_item(){
            return this.$store.getters['products/GET_PRODUCTS_ITEM'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
    },

    async mounted() {
        this.product_uuid = this.$route.params.product_uuid ? this.$route.params.product_uuid : '';
        if(this.product_uuid !== ''){

            this.title = 'Редактирование услуги';
            document.title = appConfig.title + ' - ' + 'Редактирование услуги';

            let data_send = {
                'uuid' : this.product_uuid
            }

            await this.$store.dispatch('products/FETCH_PRODUCTS_ITEM', data_send);
            this.name = this.product_item.name ? this.product_item.name : '';
            this.code = this.product_item.code ? this.product_item.code : '';
        }
    },

    methods: {

        async saveItem(){

            let data_send = {
                'name' : this.name,
                'code' : this.code
            };

            let result = '';

            if(this.product_uuid === ''){
                result = await this.$store.dispatch('products/FETCH_PRODUCTS_CREATE', data_send);
            } else {
                data_send.uuid = this.product_uuid;
                result = await this.$store.dispatch('products/FETCH_PRODUCTS_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Products'});
            }
        }
    },
}

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Код"
                                        label-for="code"
                                    >
                                        <b-form-input
                                            id="code"
                                            v-model="code"
                                            placeholder="Укажите символьный код услуги"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Название услуги"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder="Укажите название услуги"
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>

                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>

                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
